var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPazzle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 196 117.8",
    style: {
      enableBackground: "new 0 0 196 117.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#41B9C3;stroke:#41B9C3;enable-background:new    ;}\n\t.st1{fill:none;stroke:#41B9C3;stroke-linecap:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.6,37c-0.4-13.6,6.2-29.7,9.5-36L25.6,1.5c1,1.7,3.9,9,7.5,25S30.9,42.8,27.6,41 c-9.6-5.2-16.3-3.8-18.5-2.5C-2.1,46.1,0.7,56,3.6,60c3.2,6,13.7,5.2,18.5,4c7.6-3.6,10.2-0.5,10.5,1.5c0.4,8.8-4.2,24-6.5,30.5 c15.7,4.8,43,14.5,37,2c-5.5-11.5-3.3-19.2,0-22.5c10-6.8,18.5-2.2,21.5,1c1.5,2.8,3.8,10.5,1,18.5c-2.8,8,4.2,9.3,8,9 c7.6-0.8,19.5-6.3,24.5-9c-1-3.7-3.6-13.5-6-23.5c-2.4-10,4-10.5,7.5-9.5c2.8,1.6,8.5,2,11,2c10,0.8,12.5-9,12.5-14 c-2.4-14.8-13.3-14.5-18.5-12.5C114.2,43.9,110.9,39.8,110.6,37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.6,77.1c12.9,2.1,39,13,40,40.1 M190.5,117.2l4.9-6.1 M190.5,117.2l-5.9-4.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPazzle2);
export default __webpack_public_path__ + "static/media/pazzle2.2a32f8a638d49f40a0cc1365a1faefb5.svg";
export { ForwardRef as ReactComponent };